import _ from 'lodash'

const titles = content => {
    return [
        {
            property: 'og:title',
            content
        },
        {
            name: 'twitter:title',
            content
        }
    ]
}

const descriptions = content => {
    return [
        {
            name: 'description',
            content
        },
        {
            property: 'og:description',
            content
        },
        {
            name: 'twitter:description',
            content
        }
    ]
}

const url = path => (_.preload('app.url') || '') + path

export default {
    methods: {
        head () {
            return {}
        }
    },
    metaInfo () {
        return _.chain({
            title: [
                'Property management software',
                'Online rent collection, credit reporting and more'
            ],
            description: 'Manage your properties, set up tenancies, accept payments and more online with Rentora',
            meta: [
                {
                    property: 'fb:app_id',
                    content: _.preload('keys.facebook')
                },
                {
                    property: 'og:url',
                    content: url(this.$route.path)
                },
                {
                    property: 'og:site_name',
                    content: 'Rentora'
                },
                {
                    property: 'og:type',
                    content: 'website'
                },
                {
                    property: 'og:image',
                    content: url('/img/head/og.png')
                },
                {
                    property: 'og:image:width',
                    content: '1200'
                },
                {
                    property: 'og:image:height',
                    content: '630'
                },
                {
                    name: 'twitter:creator',
                    content: '@rentorauk'
                },
                {
                    name: 'twitter:card',
                    content: 'summary_large_image'
                },
                {
                    name: 'twitter:url',
                    content: url(this.$route.path)
                },
                {
                    name: 'twitter:image',
                    content: url('/img/head/twitter.png')
                }
            ],
            link: [
                {
                    vmid: 'canonical',
                    rel: 'canonical',
                    href: url(this.$route.path)
                }
            ]
        })
            .merge(this.head())
            .thru(head => {
                head.title = _.get(this.head(), 'title', head.title)

                if (!_.isArray(head.title)) {
                    head.title = [head.title]
                }

                head.title = [...head.title, 'Rentora'].join(' - ')

                const vmid = array => {
                    return _.map(array, item => {
                        if (item.name && !item.vmid) {
                            item.vmid = item.name
                            delete item.property
                        } else if (item.property && !item.vmid) {
                            item.vmid = item.property
                            delete item.name
                        }

                        return item
                    })
                }

                head.meta = _.unionBy(
                    vmid(head.meta),
                    vmid(titles(head.title)),
                    vmid(descriptions(head.description)),
                    'vmid'
                )

                return head
            })
            .value()
    }
}
